export default "__VITE_ASSET__DGJ_5sU3__"